


import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API;

axios.defaults.baseURL = `${API_BASE_URL}/deliveryagent`;
axios.defaults.timeout = 30000;
axios.defaults.headers.common['Content-Type'] = 'application/json';

export const orderAssignmentAPI = {
  getMyOrders: (userId, filter = null) => {
    const params = { user_id: userId };
    if (filter) params.filter = filter;
    return axios.get('/my-orders', { params });
  },

  acceptAssignment: (token) =>
    axios.post('/assignment/accept', { token }),

  rejectAssignment: (token, reason) =>
    axios.post('/assignment/reject', { token, reason }),

  confirmPickup: (userId, orderId, orderType, details = {}) =>
    axios.post('/dashboard/order/pickup', {
      userId,
      orderId,
      orderType,
      ...details,
    }),

collectPayment: (userId, orderId, orderType, paymentMethod, amount) =>
  axios.post('/confirm-payment', {
    userId,
    orderId,
    orderType,
    paymentMethod,
    amount,
  }),

// NEW: Alias method for PaymentCollection.js

confirmPayment: (userId, orderId, orderType, paymentData) =>
  axios.post('/confirm-payment', {
    userId,
    orderId,
    orderType,
    paymentMethod: paymentData.paymentMethod,
    amount: paymentData.amount,
    collectedAt: paymentData.collectedAt,
    deliveryType: paymentData.deliveryType || (orderType === 'booking' ? 'sample' : 'medicine'),
  }),
  confirmDelivery: (userId, orderId, orderType, details = {}) =>
    axios.post('/dashboard/order/deliver', {
      userId,
      orderId,
      orderType,
      ...details,
    }),

  reportIssue: (userId, orderId, orderType, issueType, description) =>
    axios.post('/report-issue', {
      userId,
      orderId,
      orderType,
      issueType,
      description,
    }),

  uploadPhoto: (orderId, photoFile) => {
    const formData = new FormData();
    formData.append('photo', photoFile);
    formData.append('orderId', orderId);

    return axios.post('/upload-photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  verifyDeliveryOTP: (orderId, orderType, otp,deliveryType = 'sample') =>
    axios.post('/verify-delivery-otp', {
      orderId,
      orderType,   // ← was missing; caused "medicine" string to land in otp
      otp,
      deliveryType
    }),

  // FIX 2: this method was missing entirely; PaymentCollection already calls it
  resendDeliveryOTP: (orderId, orderType,deliveryType = 'sample') =>
    axios.post('/resend-delivery-otp', {
      orderId,
      orderType,
      deliveryType,
    }),


    completeSampleCollection: (orderId, orderType, data) => {
      return axios.post('/complete-sample-collection', {
        orderId: orderId,
        orderType: orderType || 'booking',
        data: data
      });
    },

    transferToLab: (samples, transferData) =>
      axios.post('/transfer-to-lab', {
        samples,
        transferData,
      }),
   getCollectedSamples: (userId) =>
    axios.get('/my-collected-samples', {
      params: { user_id: userId }
    }),
    labReceiveSamples: (trackingNumber, labStaffId, conditionOnArrival, notes) =>
      axios.post('/lab-receive-samples', {
        trackingNumber,
        labStaffId,
        conditionOnArrival,
        notes,
      }),
  // NEW: Report collection failure for bookings/diagnostics
  reportCollectionFailure: (orderId, orderType, failureData) =>
    axios.post('/report-collection-failure', {
      orderId,
      orderType,
      ...failureData,
    }),
  getAgentProfile: (userId) =>
    axios.get('/profile', { params: { user_id: userId } }),
};
